import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056a6356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Project", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "name", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Source", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Language", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Target", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Language", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Deliver", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Time", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Unit", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Price", -1))

import { ref, Ref, reactive, onMounted } from 'vue'
import dayjs from 'dayjs'
import { boolean, string } from 'mathjs'
import { formatNumber } from '@/utils/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    title:{
        type:String,
        default:''
    },
    tableData:{
        type:Array,
        default:[],
    },
    lanNum:{
        type:Boolean,
        default:true
    }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
    _createVNode(_component_el_table, {
      class: "invoice-content-table",
      data: __props.tableData,
      border: "",
      "empty-text": "No records found.",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "projectName",
          label: "Project name",
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "poNumber",
          label: "PO No.",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "orderNo",
          label: "REF NO.",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "category",
          label: "Category",
          align: "center"
        }),
        (__props.lanNum)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "sourceLang",
              label: "Source Language",
              align: "center"
            }, {
              header: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!__props.lanNum)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "language",
              label: "Language",
              align: "center"
            }))
          : _createCommentVNode("", true),
        (__props.lanNum)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "targetLang",
              label: "Target Language",
              align: "center"
            }, {
              header: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "deliveryDate",
          label: "Deliver Time",
          formatter: (row)=>_unref(dayjs)(row.deliveryDate).format('YYYY-MM-DD'),
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "quantity",
          label: "Quantity",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          prop: "rate",
          label: "Unit Price",
          align: "right",
          formatter: _unref(formatNumber)
        }, {
          header: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "discount",
          label: "Discount",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "Sub total",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})